import { List } from 'immutable';
import MenuItemSale, { MenuItemSales } from 'records/MenuItemSale';
import BaseList from 'records/BaseList';

import {
  MENU_ITEM_SALES_ASYNC_ACTION_START,
  MENU_ITEM_SALES_ASYNC_ACTION_ERROR,
  MENU_ITEM_SALES_ASYNC_UPDATE_SUCCESS,
  MENU_ITEM_SALES_UPDATE_ACTION_SUCCESS,
  MENU_ITEM_SALES_CATEGORY_UPDATE_ACTION_SUCCESS,
  MENU_ITEM_SALES_RESET_STATE,
} from 'actions/menuItemSales';

const initialState = new BaseList({
  loading: false,
  errorMessage: null,
  data: new List(),
});

const actionsMap = {
  [MENU_ITEM_SALES_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [MENU_ITEM_SALES_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [MENU_ITEM_SALES_ASYNC_UPDATE_SUCCESS]: (state, action) => {
    let menuItemSalesData = MenuItemSales(action.data);
    menuItemSalesData = MenuItemSale.sortMenuItemSalesByOrdinal(menuItemSalesData);
    return state.merge({
      loading: false,
      errorMessage: null,
      data: menuItemSalesData,
    });
  },
  [MENU_ITEM_SALES_CATEGORY_UPDATE_ACTION_SUCCESS]: (state, action) => {
    const menuItemSalesData = MenuItemSales(action.data);
    let newMenuItemSalesData = MenuItemSale
                                .mergeMenuItemSalesByMenuItemId(state.data, menuItemSalesData, action.userCategoryId);
    newMenuItemSalesData = MenuItemSale.sortMenuItemSalesByOrdinal(newMenuItemSalesData);
    return state.merge({
      loading: false,
      errorMessage: null,
      data: newMenuItemSalesData,
    });
  },
  [MENU_ITEM_SALES_UPDATE_ACTION_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: action.data,
    });
  },
  [MENU_ITEM_SALES_RESET_STATE]: () => {
    return initialState;
  },
};

export default function menuItemSales(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
